export default "__VITE_ASSET__Cv024bOw__"